import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { useParams } from "react-router-dom";
import { cityService } from "../../services/cityService";
import { categoryService } from "../../services/categoryService";
import { tripService } from "../../services/tripService";
import Select from "react-select";
import { customerService } from "../../services/customerService";
import { urlConfig } from "../../config/baseUrl";
import no_image_available from "../../assets/images/no_image_available.png";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useValidation } from "../../hooks/useValidation";
import { createBookingSchema } from "../../validation/bookingSchema";
import BookingTrip from "./components/BookingTrip";
import BookingAddons from "./components/BookingAddons";
import { bookingService } from "../../services/bookingService";
import { toast } from "../../services/toastService";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/common/Loading";
import BackButton from "../../components/common/BackButton";

const BookingForm = () => {
  const { t ,lang} = useContext(LocaleContext);
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const [cities, setCities] = useState(null);
  const [categories, setCategories] = useState(null);
  const [trips, setTrips] = useState(null);
  const [customers, setCustomers] = useState(null);
  const [addons, setAddons] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(true);
   const initialForm = {
   cityId: "",
   categoryId: "",
   tripId: "",
   packageId: "",
   addons: [],
   customerId: "",
   noOfPeople: "",
   bookingDate: "",
   startTime: "",
   notes: "",
 };
  const v = useValidation();
  const schema = createBookingSchema(v, t, isEditMode); 
  //validation
   const {
     register,
     handleSubmit,
     setValue,
     control,
     reset,
     formState: { errors },
     watch,
   } = useForm({
     defaultValues: initialForm,
     resolver: yupResolver(schema),
   }); 
const selectedCityId = watch("cityId");
const selectedCategoryId = watch("categoryId");
  

  const options = trips?.map((s) => ({
    value: s.value,
    label: s.label[lang],
    city: s.city?.[lang],
    image: s.imagePath,
  }));
   
  useEffect(() => {
    window.scrollTo(0, 0);
    loadData();
  }, []);
  const loadData = async () => {
    try {
      setLoading(true);
      await getAllCities();
      await getAllCategories();
      await getAllCustomers();
      if (id) await editAsync();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  const editAsync = async () => {
    const response = await bookingService.edit(id);
    if (!response.isSuccess) {
      toast.error(t("anErrorOccurredPleaseTryAgainLater"));
      return;
    }
    const data = response.value;
    reset({
      cityId: data.cityId,
      categoryId: data.categoryId,
      tripId: data.tripId,
      packageId: data.packageId,
      addons: data.addons,
      customerId: data.customerId,
      noOfPeople: data.noOfPeople,
      bookingDate: data.bookingDate,
      startTime: data.startTime,
      notes: data.notes,
    });
  }
const getAllCities = async () => {
    var data = await cityService.getDropdownAsync();
    setCities(data);
  };
  const getAllCategories = async () => {
    var data = await categoryService.getDropdownAsync();
    setCategories(data);
  };
  const getAllTrips = async () => {
      var data = await tripService.getDropdownFilterAsync(
        selectedCityId,
        selectedCategoryId,
      );
      setTrips(data);
    };
  useEffect(() => {
    if (selectedCityId && selectedCategoryId) {
      getAllTrips();
    }
  }, [selectedCityId, selectedCategoryId]);
  const getAllCustomers = async () => {
    var data = await customerService.getDropdownAsync();
    setCustomers(data);
  };
   
   const onSubmit = async (data) => {
    const finalPayload = {
       ...data,
       addons: selectedAddons.length > 0 ? selectedAddons : [],
     };
     if(isEditMode) 
      await updateAsync(finalPayload);
     else
     await addAsync(finalPayload);
     
   };
   const addAsync = async(data)=>{
     try {
      setBtnLoading(true);
     var response = await bookingService.create(data);
     if (!response.isSuccess) {
       toast.error(t(response.key));
       console.log(response);
       return;
     }
     toast.success(t("recordAddedSuccessfully"));
     navigate("/bookings");
     } catch (error) {
       console.log(error);
     }
     finally{
       setBtnLoading(false);
     }
   }
    const updateAsync = async(data)=>{
     try {
      setBtnLoading(true);
     var response = await bookingService.update(id,data);
     if (!response.isSuccess) {
       toast.error(t(response.key));
       console.log(response);
       return;
     }
     toast.success(t("recordUpdatedSuccessfully"));
     navigate("/bookings");
     } catch (error) {
       console.log(error);
     }
     finally{
       setBtnLoading(false);
     }
   }
  const handleClear = () => {
    reset(initialForm); // resets to initial values
  };
     if(loading) return <Loading />
  return (
    <section className="section-booking-form">
      <div className="default-heading">{t("bookings")}</div>
      <div className="my-card">
        <div className="my-card-header d-flex justify-content-between align-items-center">
          {isEditMode ? (
            <>
              <i className="fas fa-edit"></i> {t("editOrSelectedNarrator")}
            </>
          ) : (
            <>
              <i className="fas fa-plus plus-icon"></i> {t("addNewBooking")}
            </>
          )}
          <BackButton />
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="my-card">
            <div className="my-card-header text-primary">{t("selectTrip")}</div>
            <div className="my-card-body">
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">{t("selectCity")}</label>
                    <Select
                      value={
                        cities
                          ?.map((s) => ({
                            value: s.id,
                            label: s.name[lang],
                          }))
                          .find((c) => c.value === watch("cityId")) || null
                      }
                      options={cities?.map((s) => ({
                        value: s.id,
                        label: s.name[lang],
                      }))}
                      onChange={(option) => {
                        setValue("cityId", option?.value, {
                          shouldValidate: true,
                        });
                      }}
                      placeholder={t("selectCity")}
                    ></Select>
                    {errors.cityId && (
                      <p className="text-danger">{errors.cityId.message}</p>
                    )}
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">{t("selectCategory")}</label>
                    <Select
                      value={
                        categories
                          ?.map((s) => ({
                            value: s.id,
                            label: s.name[lang],
                          }))
                          .find((c) => c.value === watch("categoryId")) || null
                      }
                      options={categories?.map((s) => ({
                        value: s.id,
                        label: s.name[lang],
                      }))}
                      onChange={(option) => {
                        setValue("categoryId", option?.value, {
                          shouldValidate: true,
                        });
                      }}
                      placeholder={t("selectCategory")}
                    ></Select>
                    {errors.categoryId && (
                      <p className="text-danger">{errors.categoryId.message}</p>
                    )}
                  </div>
                </div>

                {selectedCityId && selectedCategoryId && (
                  <BookingTrip
                    errors={errors}
                    options={options}
                    t={t}
                    watch={watch}
                    setValue={setValue}
                    urlConfig={urlConfig}
                    reset={reset}
                    setAddons={setAddons}
                    setSelectedAddons={setSelectedAddons}
                    isEditMode={isEditMode}
                  />
                )}
                <BookingAddons
                  lang={lang}
                  t={t}
                  addons={addons}
                  selectedAddons={selectedAddons}
                  setSelectedAddons={setSelectedAddons}
                />
              </div>
            </div>
          </div>

          <div className="my-card mt-3">
            <div className="my-card-header text-primary">
              {t("selectCustomer")}
            </div>
            <div className="my-card-body">
              <div className="row">
                <div className="col-12 col-md-12">
                  <div className="form-group input-icon">
                    <Select
                      value={
                        customers
                          ?.map((s) => ({
                            value: s.id,
                            label: s.name,
                          }))
                          .find((c) => c.value === watch("customerId")) || null
                      }
                      options={customers?.map((s) => ({
                        value: s.id,
                        label: s.name,
                      }))}
                      onChange={(option) => {
                        setValue("customerId", option?.value, {
                          shouldValidate: true,
                        });
                      }}
                      placeholder={t("selectCustomer")}
                    ></Select>
                    {errors.customerId && (
                      <p className="text-danger">{errors.customerId.message}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-card mt-3">
            <div className="my-card-header text-primary">
              {t("bookingDetails")}
            </div>
            <div className="my-card-body">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("noOfPeople")}</label>
                    <input
                      type="number"
                      className="form-control"
                      {...register("noOfPeople")}
                      placeholder={t("noOfPeople")}
                    />
                    {errors.noOfPeople && (
                      <p className="text-danger">{errors.noOfPeople.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("bookingDate")}</label>
                    <input
                      type="date"
                      {...register("bookingDate")}
                      className="form-control"
                    />
                    {errors.bookingDate && (
                      <p className="text-danger">
                        {errors.bookingDate.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="form-label">{t("startTime")}</label>
                    <input
                      type="time"
                      {...register("startTime")}
                      className="form-control"
                    />
                    {errors.startTime && (
                      <p className="text-danger">{errors.startTime.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-12 col-md-6 d-none">
                  <div className="form-group">
                    <label className="form-label">{t("endTime")}</label>
                    <input type="time" className="form-control" />
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="form-group">
                    <label className="form-label">{t("notes")}</label>
                    <textarea
                      {...register("notes")}
                      className="form-control"
                      placeholder={t("notes")}
                      rows={4}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 gap-2 d-flex justify-content-end">
            {!btnLoading && (
              <button type="submit" className="btn-default">
                {t("save")}
              </button>
            )}
            {btnLoading && (
              <button type="button" className="btn-default">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>
            )}
            {isEditMode && (
              <button
                type="button"
                className="btn-secondary"
                onClick={handleClear}
              >
                {t("reset")}
              </button>
            )}
            {!isEditMode && (
              <button
                type="button"
                className="btn-secondary"
                onClick={handleClear}
              >
                {t("reset")}
              </button>
            )}
          </div>
        </form>
      </div>
    </section>
  );
};

export default BookingForm;
